import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import ApiConection from 'api_ref/ApiConection';
import { ConvertDateToText, DisplayPaging } from "components/MyControl";
import { useNavigate } from "react-router-dom";
import { Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import UtilClass from "api_ref/UtilClass";

export default function UserGroup() {
    const nav = useNavigate();
    const api = new ApiConection();
    const util = new UtilClass();

    const [filterDispaly, setFilterDisplay] = useState(false);
    const [loading, setLoading] = useState(false);

    const [dataTable, setDataTable] = useState({
        arr_table: [],
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    })
    const [search, setSearch] = useState({
        name: '',
        description: '',
        identity_role: '',
        active: '',
        page: util.getCombinedSessionStorage('/usergroups','page') ?? 1,
        size: util.getCombinedSessionStorage('/usergroups','size') ?? 10
    })

    const callAipUsers = async () => {
        let data = {
            search: {
            },
            pagination: {
                page: search.page,
                size: search.size
            }
        }

        if (search.name != '')
            data.search.name = search.name;
        if (search.identity_role != '')
            data.search.identity_role = search.identity_role;
        if (search.active != '')
            data.search.active = (search.active == true || search.active == 'true');

        setLoading(true);

        const response_pagination = await api.postData('api/UsersGroup/Pagination', data);
        if (response_pagination.status === true) {
            handleSetDataTable('record_start', response_pagination.data.record_start);
            handleSetDataTable('record_count', response_pagination.data.record_count);
            handleSetDataTable('page_count', response_pagination.data.page_count);
        }

        const response_result = await api.postData(`api/UsersGroup/result`, data);
        if (response_result.status == true) {
            handleSetDataTable('arr_table', response_result.data);
        } else {
            handleSetDataTable('arr_table', []);
        }

        let record_end = response_pagination.data.record_start + (search.size - 1);
            if (record_end > response_pagination.data.record_count) {
                record_end = response_pagination.data.record_count;
            }

            handleSetDataTable('record_end', record_end);

            setLoading(false);
    }

    const handleSetDataTable = (name, value) => {
        setDataTable(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;

        util.setCombinedSessionStorage('/usergroups','page',1);
        util.setCombinedSessionStorage('/usergroups','size',value);

        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }

    const handlePagingChange = (page_no) => {

        util.setCombinedSessionStorage('/usergroups','page',page_no);

        handleSetSearch('page', page_no);
    }

    const handleQuickSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch('name', value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const handleFullSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch(name, value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    useEffect(() => {
        if (search !== undefined) {
            const delay = setTimeout(() => {
                callAipUsers();
            }, 500);

            return () => clearTimeout(delay);
        }
    }, [search])

    const handleDetail = (id) => {
        nav(`/usergroups/edit/${id}`);
    }
    const handleCreate = () => {
        nav('/usergroups/create')
    }

    return (
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <div className={Css.Graph_Box + ' shadow'}>
                        <div className={Css.Content}>
                            <div className={Css.Header}>
                                <div className="d-flex">
                                    <h6 className="d-flex align-items-center">จัดการสิทธิ์ผู้ใช้</h6>
                                    <div className="flex-fill">
                                        <Form.Group as={Row}>
                                            <Form.Label column sm={4} className="text-end">ค้นหา</Form.Label>
                                            <Col>
                                                <InputGroup>
                                                    <Form.Control placeholder="ค้นหาที่นี่" id={'txtQuickSearch'} value={search.name}
                                                        disabled={filterDispaly}
                                                        onChange={(event) => handleQuickSearch(event)} />
                                                    <Button variant="outline-secondary" onClick={event => setFilterDisplay(!filterDispaly)}>
                                                        {
                                                            filterDispaly === true &&
                                                            <i className="fa-solid fa-arrow-up-short-wide"></i>
                                                        }
                                                        {
                                                            filterDispaly === false &&
                                                            <i className="fa-solid fa-arrow-down-short-wide"></i>
                                                        }
                                                        <span></span>
                                                    </Button>
                                                    <Button>
                                                        <i className="fa-solid fa-magnifying-glass"></i>
                                                    </Button>
                                                </InputGroup>

                                            </Col>
                                        </Form.Group>

                                    </div>
                                </div>
                                {
                                    filterDispaly === true &&
                                    <div className="d-flex bg-">
                                        <div className="w-100 bg-light p-3">
                                            <Row className="mb-2">
                                                <Col>
                                                    <Form.Label>ชื่อ</Form.Label>
                                                    <Form.Control name={'name'} value={search.name} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>สำหรับระบบ</Form.Label>
                                                    <Form.Control name={'identity_role'} value={search.identity_role} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                <Form.Label>สถานะ</Form.Label>
                                                    <Form.Select name={'active'} value={search.active} onChange={handleFullSearch}>
                                                        <option value={''}>ทั้งหมด</option>
                                                        <option value={true}>อนุญาตใช้งาน</option>
                                                        <option value={false}>ไม่อนุญาตใช้งาน</option>
                                                    </Form.Select>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className={Css.Content + ' position-relative'}>
                                {
                                    loading &&
                                    <div className="position-absolute w-100 h-100 bg-white bg-opacity-50" style={{ zIndex: 5 }}>
                                        <div className="d-flex justify-content-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className={Css.Content + ' position-relative'}>
                                    <Button variant="outline-success" className="d-flex justify-content-center" onClick={event => handleCreate()}>
                                        <i className="fa-solid fa-plus me-2 mt-1"></i>เพิ่มสิทธิ์ผู้ใช้
                                    </Button>
                                </div>

                                <div className="table-responsive border rounded">

                                    <table className="table text-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th ></th>
                                                <th>#</th>
                                                <th className="text-start" >ชื่อ</th>
                                                <th className="text-start" >รายละเอียด</th>
                                                <th className="text-start" >สำหรับระบบ</th>
                                                <th>วันที่สร้าง</th>
                                                <th>วันที่แก้ไข</th>
                                                <th className="text-start">แก้ไขโดย</th>
                                                <th>สถานะ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dataTable.arr_table.length > 0 &&
                                                dataTable.arr_table.map((obj, index) =>{
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <button className="btn btn-edit-icon" onClick={event => handleDetail(obj.id)} >
                                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                                </button>
                                                            </td>
                                                            <td>{dataTable.record_start + index}</td>
                                                            <td className="text-start">{obj.name}</td>
                                                            <td className="text-start">{obj.description}</td>
                                                            <td className="text-start">{obj.identity_role}</td>
                                                            <td>{ConvertDateToText(obj.create_date)}</td>
                                                            <td>{ConvertDateToText(obj.modify_date)}</td>
                                                            <td className="text-start">{obj.modify_by}</td>
                                                            <td>{obj.active == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>
                                                                : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <DisplayPaging rec_start={dataTable.record_start}
                                    rec_end={dataTable.record_end}
                                    rec_count={dataTable.record_count}
                                    onSizeChange={handleSizeTableChange}
                                    cur_page={search.page}
                                    size={search.size}
                                    page_count={dataTable.page_count}
                                    onPagingChange={handlePagingChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout4Admin1>
    )
}